export const enum RouterName {
  Home = "/",
  Recommend = "/recommend",
  SongSheet = "/song-sheet",
  SongSheetDetail = "/song-sheet-detail",
  Singer = "/singer",
  SingerDetail = "/singer-detail",
  Personal = "/personal",
  Setting = "/setting",
  PersonalData = "/personal-data",
  SignIn = "/sign-in",
  SignUp = "/sign-up",
  Search = "/search",
  Lyric = "/lyric",
  Error = "/404",
  SignOut = "0",
  ForgotPassword="/FPassword",
  loginByemail="/loginByemail",
}
